import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingScreen = observer(() => {
    return (
        <div className="w-screen h-[100dvh] flex justify-center items-center bg-[#efefef] z-50 absolute top-0 left-0">
            {/* <div className="flex flex-col gap-[8px] items-center p-[16px] bg-theme-white rounded-[8px] shadow-theme-shadow">
                <div className="w-[150px] h-[84px] flex justify-center items-center">
                    <img src={`${PUBLIC_URL}/assets/gif/loading.gif`} alt="" />
                </div>
                <p className="font-normal text-sm text-theme-black">
                    Just a Moment....
                </p>
                <p className="font-normal text-sm text-theme-black">
                    We are customizing something amazing for you
                </p>
            </div> */}
            <Spin
                indicator={
                    <LoadingOutlined
                        style={{ fontSize: 48, color: '#f46147' }}
                        spin
                    />
                }
            />
        </div>
    );
});

export default LoadingScreen;
